import {makeAutoObservable} from "mobx";

export default class ProgressStore {
    constructor() {
        makeAutoObservable(this);
    }

    isLoading = false;
    setIsLoading = isLoading => this.isLoading = isLoading;
}